// Virtual background images - using verified working URLs with CORS support
export const backgroundImageUrls = [
    // VideoSDK CDN images (verified working)
    "https://cdn.videosdk.live/virtual-background/beach.jpeg",
    "https://cdn.videosdk.live/virtual-background/cloud.jpeg",
    "https://cdn.videosdk.live/virtual-background/san-fran.jpeg",
    "https://cdn.videosdk.live/virtual-background/paper-wall.jpeg",
    // Picsum photos (always works with CORS)
    "https://picsum.photos/seed/office/1280/720",     // Office-style
    "https://picsum.photos/seed/mountain/1280/720",   // Mountain
    "https://picsum.photos/seed/nature/1280/720",     // Nature
    "https://picsum.photos/seed/city/1280/720",       // City
];

// Original DigitalOcean backgrounds (need CORS configuration on DO Spaces)
// Uncomment these once CORS is configured:
// export const backgroundImageUrlsOriginal = [
//     "https://r-link-dev.nyc3.digitaloceanspaces.com/background/office-1280-1.jpg",
//     "https://r-link-dev.nyc3.digitaloceanspaces.com/background/office-space-1280-1.jpg",
//     "https://r-link-dev.nyc3.digitaloceanspaces.com/background/lobby-1280-1.jpg",
//     "https://r-link-dev.nyc3.digitaloceanspaces.com/background/meeting-room-1280-2.jpg",
//     "https://r-link-dev.nyc3.digitaloceanspaces.com/background/sky-2.jpg",
//     "https://r-link-dev.nyc3.digitaloceanspaces.com/background/coffee-shop-1280-1.jpg",
//     "https://r-link-dev.nyc3.digitaloceanspaces.com/background/samos-1280-1.jpg",
//     "https://r-link-dev.nyc3.digitaloceanspaces.com/background/cafe-1280-2.jpg",
//     "https://r-link-dev.nyc3.digitaloceanspaces.com/background/cafe-1280-1.jpg",
//     "https://r-link-dev.nyc3.digitaloceanspaces.com/background/coworking-1280-1.jpg",
//     "https://r-link-dev.nyc3.digitaloceanspaces.com/background/saxon-switzerland-539418_1280.jpg",
//     "https://r-link-dev.nyc3.digitaloceanspaces.com/background/porch-691330_1280.jpg",
//     "https://r-link-dev.nyc3.digitaloceanspaces.com/background/mountains-1280-1.jpg",
//     "https://r-link-dev.nyc3.digitaloceanspaces.com/background/splashing-1280-1.jpg",
//     "https://r-link-dev.nyc3.digitaloceanspaces.com/background/nature-1280-1.jpg",
//     "https://r-link-dev.nyc3.digitaloceanspaces.com/background/aurora-1.jpg"
// ];